module.exports = __webpack_public_path__ + "static/media/md-subway.265774e7.svg";